/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */
import React from 'react';
import IconComponent from '@atlaskit/icon/core/epic';
import ObjectBase from '../object-base';
export default function EpicObject(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Epic' : _ref$label,
    size = _ref.size,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(ObjectBase, {
    label: label,
    size: size,
    testId: testId,
    icon: IconComponent,
    color: "var(--ds-icon-accent-purple, #8270DB)"
  });
}